import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal, ModalHeader, ModalBody } from "reactstrap";
import { Link } from "react-router-dom";
import axios from "axios";

// Görseller & API'ler
import tahsilat360Logo from "../../assets/images/tahsilat360_logo2.png";
import { API } from "../../api/urls";

/* -------------------------------------------------- Sabitler -------------------------------------------------- */
const CONTRACT_ENDPOINT = {
  CANCELLATION: API.contract_cancel_return_privacy,  // /api/companies/contract/cancellation-return-privacy
  KVKK        : API.contract_personal_data,          // /api/companies/contract/personal-data-policy
  SERVICE     : API.contract_service_agreement       // /api/companies/contract/service-agreement
};

const Footer = () => {
  /* ---------------------------------------------- State ------------------------------------------------------ */
  const [companyId, setCompanyId] = useState(null);

  const [contractModal, setContractModal] = useState({
    open : false,
    title: "",
    html : "",
    busy : false
  });

  const [contactModal, setContactModal] = useState({
    open : false,
    busy : false,
    data : null,
    error: null
  });

  /* ------------------------------ Login’den girilmiş şirket bilgisini al ------------------------------------- */
  useEffect(() => {
    const authUserStr = localStorage.getItem("authUser");
    if (authUserStr) {
      try {
        const authUser = JSON.parse(authUserStr);
        setCompanyId(
            authUser.user?.companyId ?? authUser.companyId ?? null
        );
      } catch { /* eslint-disable no-empty */ }
    }
  }, []);

  /* ------------------------------------------ Modal Açma Fonksiyonları --------------------------------------- */
  const openContractModal = async (type) => {
    setContractModal(prev => ({ ...prev, open: true, busy: true, html: "", title: "" }));
    try {
      const urlFunc = CONTRACT_ENDPOINT[type];
      const url     = urlFunc(companyId);
      const res     = await axios.get(url); // public → token yok

      if (res.data.statusCode !== 200 || !res.data.data)
        throw new Error(res.data.message || "Sözleşme bulunamadı");

      const titles = {
        CANCELLATION: "İptal / İade Koşulları ve Gizlilik",
        KVKK        : "Kişisel Veriler Politikası",
        SERVICE     : "Hizmet Sözleşmesi"
      };

      setContractModal({
        open : true,
        busy : false,
        html : res.data.data,
        title: titles[type]
      });
    } catch (err) {
      setContractModal({
        open : true,
        busy : false,
        html : `<p class="text-danger">Sözleşme bulunamadı.</p>`,
        title: "Uyarı"
      });
      console.error("Contract fetch error:", err);
    }
  };

  const openContactModal = async () => {
    setContactModal({ open: true, busy: true, data: null, error: null });
    try {
      const res = await axios.get(API.get_company_info_by_domain); // public → token yok
      if (res.data.statusCode !== 200 || !res.data.data)
        throw new Error(res.data.message || "Bilgi bulunamadı");

      setContactModal({
        open : true,
        busy : false,
        data : res.data.data,
        error: null
      });
    } catch (err) {
      console.error("Contact fetch error:", err);
      setContactModal({
        open : true,
        busy : false,
        data : null,
        error: "İletişim bilgileri alınamadı"
      });
    }
  };

  /* ------------------------------------------------- JSX ----------------------------------------------------- */
  return (
      <>
        <footer
            className="footer"
            style={{
              minHeight: "60px",
              overflow: "visible",
              marginTop: 0,
              paddingTop: "6px",
            }}
        >
          <Container fluid>
            <Row className="align-items-center" style={{ margin: 0 }}>
              <Col style={{ padding: "6px 15px" }}>
                {/* Desktop */}
                <div className="d-none d-lg-flex align-items-center justify-content-between flex-wrap gap-2">
                  {/* Sol */}
                  <div
                      className="d-flex align-items-center flex-wrap gap-2"
                      style={{ flex: 1, minWidth: 0 }}
                  >
                    <a
                        href="https://tahsilat360.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="d-flex align-items-center text-decoration-none"
                        style={{ flexShrink: 0 }}
                    >
                      <img
                          src={tahsilat360Logo}
                          alt="Tahsilat360"
                          style={{ height: "48px", width: "auto", marginRight: "4px" }}
                      />
                    </a>
                    <span>
                    {new Date().getFullYear()} ©{" "}
                      <a
                          href="https://tahsilat360.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none ms-1"
                      >
                      Tahsilat360
                    </a>
                    .
                  </span>
                    <span className="text-muted">|</span>
                    <span
                        className="text-muted text-decoration-none small"
                        role="button"
                        onClick={openContactModal}
                    >
                    İletişim
                  </span>
                    <span
                        className="text-muted text-decoration-none small"
                        role="button"
                        onClick={() => openContractModal("CANCELLATION")}
                    >
                    İptal, İade Koşulları ve Gizlilik
                  </span>
                    <span
                        className="text-muted text-decoration-none small"
                        role="button"
                        onClick={() => openContractModal("KVKK")}
                    >
                    Kişisel Veriler Politikası
                  </span>
                    <span
                        className="text-muted text-decoration-none small"
                        role="button"
                        onClick={() => openContractModal("SERVICE")}
                    >
                    Hizmet Sözleşmesi
                  </span>
                  </div>

                  {/* Sağ */}
                  <div
                      className="d-flex align-items-center flex-wrap gap-1"
                      style={{ flexShrink: 0 }}
                  >
                    <img src="/images/secure-payment/footer-logo-visa.png" alt="Visa" style={{ height: "16px" }} />
                    <img src="/images/secure-payment/footer-logo-mastercard.png" alt="Mastercard" style={{ height: "16px" }} />
                    <img src="/images/secure-payment/troy-logo.svg" alt="Troy" style={{ height: "16px" }} />
                  </div>
                </div>

                {/* Tablet */}
                <div className="d-none d-md-block d-lg-none">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex align-items-center gap-2">
                      <a
                          href="https://tahsilat360.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="d-flex align-items-center text-decoration-none"
                      >
                        <img
                            src={tahsilat360Logo}
                            alt="Tahsilat360"
                            style={{ height: "40px", width: "auto", marginRight: "4px" }}
                        />
                      </a>
                      <span className="small">
                      {new Date().getFullYear()} ©{" "}
                        <a
                            href="https://tahsilat360.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none ms-1"
                        >
                        Tahsilat360
                      </a>
                      .
                    </span>
                    </div>

                    <div className="d-flex align-items-center flex-wrap gap-1">
                      <img src="/images/secure-payment/footer-logo-visa.png" alt="Visa" style={{ height: "14px" }} />
                      <img src="/images/secure-payment/footer-logo-mastercard.png" alt="Mastercard" style={{ height: "14px" }} />
                      <img src="/images/secure-payment/troy-logo.svg" alt="Troy" style={{ height: "14px" }} />
                    </div>
                  </div>

                  <div className="d-flex flex-wrap gap-2 justify-content-center">
                  <span
                      className="text-muted text-decoration-none small"
                      role="button"
                      onClick={openContactModal}
                  >
                    İletişim
                  </span>
                    <span className="text-muted">|</span>
                    <span
                        className="text-muted text-decoration-none small"
                        role="button"
                        onClick={() => openContractModal("CANCELLATION")}
                    >
                    İptal, İade Koşulları
                  </span>
                    <span className="text-muted">|</span>
                    <span
                        className="text-muted text-decoration-none small"
                        role="button"
                        onClick={() => openContractModal("KVKK")}
                    >
                    Kişisel Veriler
                  </span>
                    <span className="text-muted">|</span>
                    <span
                        className="text-muted text-decoration-none small"
                        role="button"
                        onClick={() => openContractModal("SERVICE")}
                    >
                    Hizmet Sözleşmesi
                  </span>
                  </div>
                </div>

                {/* Mobil */}
                <div className="d-block d-md-none text-center">
                  <div className="d-flex align-items-center justify-content-center mb-2">
                    <a
                        href="https://tahsilat360.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="d-flex align-items-center text-decoration-none"
                    >
                      <img
                          src={tahsilat360Logo}
                          alt="Tahsilat360"
                          style={{ height: "52px", width: "auto", marginRight: "4px" }}
                      />
                    </a>
                    <span className="small">{new Date().getFullYear()} © Tahsilat360</span>
                  </div>

                  <div className="d-flex align-items-center justify-content-center flex-wrap gap-1 mb-2">
                    <img src="/images/secure-payment/footer-logo-visa.png" alt="Visa" style={{ height: "12px" }} />
                    <img src="/images/secure-payment/footer-logo-mastercard.png" alt="Mastercard" style={{ height: "12px" }} />
                    <img src="/images/secure-payment/troy-logo.svg" alt="Troy" style={{ height: "12px" }} />
                  </div>

                  <div className="d-flex flex-wrap gap-1 justify-content-center small">
                  <span
                      className="text-muted text-decoration-none"
                      role="button"
                      onClick={openContactModal}
                  >
                    İletişim
                  </span>
                    <span className="text-muted">•</span>
                    <span
                        className="text-muted text-decoration-none"
                        role="button"
                        onClick={() => openContractModal("CANCELLATION")}
                    >
                    Koşullar
                  </span>
                    <span className="text-muted">•</span>
                    <span
                        className="text-muted text-decoration-none"
                        role="button"
                        onClick={() => openContractModal("KVKK")}
                    >
                    Gizlilik
                  </span>
                    <span className="text-muted">•</span>
                    <span
                        className="text-muted text-decoration-none"
                        role="button"
                        onClick={() => openContractModal("SERVICE")}
                    >
                    Sözleşme
                  </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </footer>

        {/* ------------------------------ Sözleşme Modalı ------------------------------ */}
        <Modal
            isOpen={contractModal.open}
            toggle={() => setContractModal(p => ({ ...p, open: false }))}
            size="lg"
        >
          <ModalHeader toggle={() => setContractModal(p => ({ ...p, open: false }))}>
            {contractModal.title}
          </ModalHeader>
          <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
            {contractModal.busy ? (
                <div className="text-center py-4">
                  <span className="spinner-border" />
                </div>
            ) : (
                <div
                    style={{ whiteSpace: "pre-wrap" }}
                    dangerouslySetInnerHTML={{ __html: contractModal.html }}
                />
            )}
          </ModalBody>
        </Modal>

        {/* ------------------------------ İletişim Modalı ------------------------------ */}
        <Modal
            isOpen={contactModal.open}
            toggle={() => setContactModal(p => ({ ...p, open: false }))}
        >
          <ModalHeader toggle={() => setContactModal(p => ({ ...p, open: false }))}>
            İletişim Bilgileri
          </ModalHeader>
          <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
            {contactModal.busy && (
                <div className="text-center py-4">
                  <span className="spinner-border" />
                </div>
            )}

            {!contactModal.busy && contactModal.error && (
                <p className="text-danger">{contactModal.error}</p>
            )}

            {!contactModal.busy && contactModal.data && (
                <div style={{ whiteSpace: "pre-wrap" }}>
                  <strong>{contactModal.data.companyName}</strong>{"\n\n"}

                  {contactModal.data.phoneNumber && (
                      <>
                        <strong>Telefon:</strong> {contactModal.data.phoneNumber}{"\n"}
                      </>
                  )}

                  {contactModal.data.contactEmail && (
                      <>
                        <strong>E-posta:</strong> {contactModal.data.contactEmail}{"\n"}
                      </>
                  )}

                  {contactModal.data.address && (
                      <>
                        <strong>Adres:</strong>{"\n"}
                        {contactModal.data.address}
                      </>
                  )}
                </div>
            )}
          </ModalBody>
        </Modal>
      </>
  );
};

export default Footer;